import { ProviderCountPerClaimsVolumePerLOB, ProviderHubFiltersRequestModel } from "@app/projects/network-assessment/provider-hub/interfaces";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

export interface ClaimsVolumeBreakdownResult {
  data: ProviderCountPerClaimsVolumePerLOB[] | undefined;
  hasData: boolean;
  isError: boolean;
  isLoading: boolean;
}

export const CLAIMS_VOLUME_BREAKDOWN_QUERY_KEY_PREFIX = "pci-dashboard__claims-volume-breakdown";

export const useClaimsVolumeBreakdown = (providerFiltersRequestModel: ProviderHubFiltersRequestModel | null): ClaimsVolumeBreakdownResult => {
  const providerHubService = useRef(new ProviderHubService()).current;

  const queryResult = useQuery<ProviderCountPerClaimsVolumePerLOB[]>({
    enabled: providerFiltersRequestModel !== null,
    queryFn: async ({ signal }) => providerHubService.getPciDashboardClaimsVolumeBreakdownData(providerFiltersRequestModel, signal),
    queryKey: [CLAIMS_VOLUME_BREAKDOWN_QUERY_KEY_PREFIX, JSON.stringify(providerFiltersRequestModel)],
    staleTime: 5 * 60 * 1000,
  });

  return {
    data: queryResult.data,
    hasData: queryResult.isSuccess && queryResult.data.some(x => x.providerCount > 0),
    isError: queryResult.isError,
    isLoading: queryResult.isFetching,
  };
}